module.exports = __webpack_public_path__ + "img/388.f821265c.jpg";